import { render, staticRenderFns } from "./PaternityExam.vue?vue&type=template&id=7f8783a4"
import script from "./PaternityExam.vue?vue&type=script&lang=js"
export * from "./PaternityExam.vue?vue&type=script&lang=js"
import style0 from "./PaternityExam.vue?vue&type=style&index=0&id=7f8783a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports